import React, { useContext } from 'react';

import Slider from '@material-ui/lab/Slider';
import AvatarEditor from 'react-avatar-editor';

import Button from '../../../../../../components/Button';
import { PX } from '../../../../../../contrib/ui';
import { GlobalContext } from '../../../../../../store';

interface ISavePictureStep {
  back: () => void;
  editorRef: React.RefObject<any>;
  handleZoom: (_: any, zoomToSet: number) => void;
  saveEdit: () => Promise<any>;
  zoom: number;
}

export const SavePictureStep = (props: ISavePictureStep) => {
  const { editorRef, zoom, handleZoom, saveEdit, back } = props;

  const {
    avatar: { clubBase64: backgroundImage }
  } = useContext(GlobalContext);

  return (
    <div className="home account-settings wrapper">
      <div className="edit-picture-wrapper">
        <div className="picture-editor">
          <div className="filter" style={{ backgroundImage }}>
            <div className="mask" />
          </div>
          <AvatarEditor
            ref={editorRef}
            image={backgroundImage}
            width={220 * PX}
            height={220 * PX}
            border={0}
            color={[55, 55, 55, 0.7]} // RGBA
            scale={zoom}
            rotate={0}
            borderRadius={110 * PX}
          />
        </div>

        <div className="zoom-title">ZOOM</div>
        <div className="slider-wrapper">
          <Slider
            classes={{
              track: 'zoom-slider-track',
              trackAfter: 'zoom-slider-track-after',
              trackBefore: 'zoom-slider-track-before'
            }}
            value={zoom}
            className="zoom-slider"
            aria-labelledby="label"
            onChange={handleZoom}
            min={1}
            max={3}
          />
          <div className="radius-left">
            <div className="hack" />
          </div>
          <div className="radius-right">
            <div className="hack" />
          </div>
        </div>

        <Button
          id="next"
          onClick={saveEdit}
          variant="contained"
          color="primary"
          fullWidth={true}
          className="button button-shadow "
        >
          SAVE EDITS
        </Button>
        <Button
          id="back"
          onClick={back}
          variant="outlined"
          color="primary"
          fullWidth={true}
          className="button"
        >
          CHANGE PICTURE
        </Button>
      </div>
    </div>
  );
};
